import axios from 'axios'
import { apiErrorHandler, apiCatchError } from 'common/utils/api'
import { getAxiosConfig } from './helper'

export function serviceGetExhibitors(eventId, success, error) {
  return axios.get(`/events/${eventId}/attendees/me/exhibitors`, getAxiosConfig())
    .then((response) => success(response.data), apiErrorHandler(error, 'backend'))
    .catch((response) => apiCatchError(response))
}
